import { THEME } from "../../styles/theme";

const CarouselDot = (props: { active: boolean }) => {
  return (
    <div
      style={{
        width: 10,
        height: 10,
        borderRadius: "100%",
        backgroundColor: props.active ? THEME.palette.primary.main : "#d9d9d9",
        margin: "0 5px 5px 5px",
      }}
    />
  );
};

export default CarouselDot;
